import { Component } from '@angular/core';

@Component({
  selector: 'ui-table-responsive',
  templateUrl: './table-responsive.component.html'
})
export class TableResponsiveComponent {

}